<template>
  <div>
    <!-- curRec {{ curRec.storage_size }} -->

    <d-table
      v-if="tableReady"
      :data_object="data_object"
      :getFreshData="true"
      :mobileBreakpoint="'0'"
      :onDataReceived="onDataReceived"
      :beforeSave="beforeSave"
      :getRowClass="getRowClass"
      :coloredFields="coloredFields"
      :getItemColor="getItemColor"
      :itemsPerPage="15"
      :filterCondition="filterCondition"
      :searchableColumns="searchableColumns"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="false"
      :showGroupBy="false"
      sortBy="storage_id"
      :sortDesc="true"
      v-bind="vBind"
      :insertable="false"
      :editRow="true"
      :alwaysUpdate="true"
      :addButtonCaption="addButtonCaption"
      tableName="storage"
      :defaultModel="defaultModel"
      :hideAllTabFilter="hideAllTabFilter"
      :hideEditedTabs="hideEditedTabs"
      :hideFilterTabs="hideFilterTabs"
      :noTabs="noTabs"
      :hideTopBar="hideTopBar"
    />
    <!-- <v-toolbar flat>
      <v-btn class="mr-2" icon @click="addStorage()" small>
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </v-toolbar> -->
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  name: "Storage",
  components: {
    DTable: () => import("../components/Table.vue"),
  },
  props: {},
  data() {
    return {
      addButtonCaption: "Add Storage",
      hideAllTabFilter: false,
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      link: {
        field: "storage_id",
        name: "storage-detail",
      },

      data_object: {
        object_name: "storage",

        mobileBreakpoint: 0,
        all_records: true,

        table_title: "Storage",
        hasSearch: true,
      },

      serviceTypes: [],
      leadStatus: [],
      stages: [],
      filterTabs: [],
      hideEditedTabs: false,
      hideFilterTabs: false,
      originalRecords: [],
      searchableColumns: [],
      vBind: {},
      curRec: null,
      storage_id: null,
      defaultModel: { customer: {} },
      customerName: "",
    };
  },
  activated() {
    this.initStorage();
  },
  mounted() {
    var that = this;
    this.initStorage();
    // this.$root.$on("tableChanged", (tbl, keys) => {
    //   // console.log(tbl);
    //   if (tbl.tableName == "inventory" && that.curRec) {
    //     try {
    //       that.curRec.storage_size = fun.calculateInventoryVolume(tbl.table);
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    // });

    this.$root.$on("arrayElementClick", (obj) => {
      var customer = obj.obj.parentObject.customer;
      var item = {
        shipment_id: obj.item,
        first_name: customer.contact.first_name,
        last_name: customer.contact.last_name,
      };
      that.linkClick(item);
    });
    this.$root.$on("customBtnClick", (obj) => {
      // if (that._uid != that.$root.shipmentUid) {
      //   return;
      // }
      if (obj.btn == "customerProfile") {
        console.log(obj.frm.model._id);
        var customerName =
          obj.frm.model.type_of_customer == "commercial"
            ? obj.frm.model.customer_name
            : obj.frm.model.contact.first_name +
              " " +
              obj.frm.model.contact.last_name;

        var item = {
          icon: "mdi-account",
          text: "Customer " + customerName,

          link: "/customers/" + obj.frm.model._id,
          customer_id: obj.frm.model._id,

          permitted: true,
        };
        this.$root.addResentTab(item);
      }

      if (obj.btn == "assignStorage") {
        console.log("assignStorage");
        var assignStorage = obj.tbl.toolBarControls.find((c) => {
          return c.id == "assignStorage";
        });
        if (assignStorage["v-bind"]["input-value"] == "Assign Storage") {
          assignStorage["v-bind"]["input-value"] = "Assign Storage To Selected";
          // assignStorageCmb.hidden = false;
          obj.tbl.toolBarKey = !obj.tbl.toolBarKey;
          obj.tbl.selected = [];
          obj.tbl.select = !obj.tbl.select;
          obj.tbl.closeMenuOnClick = false;
        } else {
          that.errorMessage = "";
          obj.tbl.closeMenuOnClick = true;
          var inv = obj.tbl;
          // console.log(inv.selected);
          // console.log(obj.model);
          if (!inv.selected.length) {
            that.errorMessage = "Please select records to assign storage";
            return;
          }

          inv.selected.forEach((i) => {
            i.storage_id = inv.parentObject.storage_id.toString();
          });
          // inv.closeMenuOnClick = true;
          assignStorage["v-bind"]["input-value"] = "Assign Storage";
          // inv.closeMenuOnClick = true;
        }
      }
    });
    // this.$root.$on("tableMounted", (obj) => {
    //   // console.log(obj);
    //   if (obj.tableName == "inventory") {
    //     // console.log(obj);
    //     var excludedFields = ["from", "to", "room"];
    //     excludedFields.forEach((f) => {
    //       delete obj.data_object.schema.properties[f];
    //     });

    //     obj.computedHeaders = obj.computedHeaders.filter((h) => {
    //       return !excludedFields.includes(h.value);
    //     });
    //     obj.tableKey = !obj.tableKey;
    //   }
    // });

    this.$root.$on("tableSelectionChanged", (obj) => {
      // var obj = fun.getParentByProperty(d.tbl, "storage_id");
      // if (obj && that.$root.shipmentUid != obj._uid && !that.linkedObjectSelected) {
      //   return;
      // }
      // that.linkedObjectSelected = true;
      if (
        obj.data_object &&
        obj.data_object.object_name == "v_customer_orders"
      ) {
        var data = {
          object_name: "customer",
          qry: {
            _id: obj.selected[0]._id,
          },
        };
        axios
          .post(this.serverURL + "/get_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            obj.dObject.model.customer = response.data.model[0];
          });
      }
      if (obj.table_title == "Departments") {
        this.department = "";
        if (obj.selected.length) {
          this.department = obj.selected[0].department_name;
        }
      }
    });
  },
  beforeDestroy() {},
  methods: {
    beforeSave(r) {
      if (r.customer && r.customer.type_of_customer == "commercial") {
        r.customer_name = (r.customer.company + " " + this.department).trim();
      } else {
        r.customer_name = r.contact.first_name + " " + r.contact.last_name;
      }
    },
    initStorage() {
      if (
        !this.$route.params.id ||
        (this.$route.params.id &&
          !this.$route.params.id.toString().split(":")[1])
      ) {
        this.tableReady = true;
      } else {
        var shipment_id = this.$route.params.id.split(":")[1];
        if (shipment_id) {
          var data = {
            object_name: "shipment",
            qry: {
              _id: shipment_id,
            },
          };
          axios
            .post(this.serverURL + "/get_data", data, {
              withCredentials: true,
            })
            .then((response) => {
              this.defaultModel = {
                customer: response.data.model[0].customer,
                inventory: response.data.model[0].inventory,
              };
              // this.hideAllTabFilter = true;
              this.hideEditedTabs = true;
              this.hideFilterTabs = true;
              this.hideTopBar = true;
              // this.noTabs = true;
              this.tableReady = true;
              this.tableKey = !this.tableKey;
            });
        }
      }
    },
    addStorage() {
      this.$root.addResentTab({ storage_id: "0", name: "storage-detail" });
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
    getItemColor(value, field) {
      var color = "black";
    },
    updateShipment(r) {
      if (!r.shipment_in) {
        var data = {
          object_name: "shipment",
          id_fields: ["customer"],
          qry: {
            customer: r.customer._id,
          },
        };
        axios
          .post(this.serverURL + "/get_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            console.log(response.data);
            var shipments = response.data.model;
            shipments.forEach((s) => {
              if (
                s.storage_id &&
                s.storage_id.length &&
                s.storage_id.includes(r.storage_id)
              ) {
                r.shipment_in = [s.shipment_id];
              }
            });
          });
      }
    },
    onDataReceived(data) {
      this.vBind = data.schema["v-bind"];

      var classes = "";

      this.$root.dynamicClasses(classes);
      // this.tableKey = !this.tableKey;
      data.table = data.model;

      // data.model.forEach((m) => {
      //   this.updateShipment(m);
      // });

      return data;
    },
  },
};
</script>

<style lang="css" scoped></style>
